var React = require('react');

function IcDownload (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"nonzero","stroke":"#FFF","strokeWidth":".5"},[React.createElement("path",{"d":"M9.562 16.734V1.982c0-.49.33-.941.808-.98a.947.947 0 0 1 1.029.941V16.81c0 .49-.478.941-1.03.903-.477-.038-.807-.49-.807-.98z","key":0}),React.createElement("path",{"d":"m9.783 19.708-6.1-6.7c-.33-.376-.367-.94-.037-1.317a.928.928 0 0 1 1.36-.038l5.473 6.022 5.474-6.06a.873.873 0 0 1 1.359.038c.33.376.257.94-.037 1.317l-6.097 6.738c-.404.414-1.028.414-1.395 0zM19.152 24H1.884c-.441 0-.846-.338-.882-.791-.037-.526.368-.98.846-.98h17.269c.44 0 .845.339.88.792.037.526-.368.979-.845.979z","key":1})]));
}

IcDownload.defaultProps = {"width":"21","height":"25","viewBox":"0 0 21 25"};

module.exports = IcDownload;

IcDownload.default = IcDownload;
